import React, { ChangeEvent } from 'react';

import FormInvalid from './FormInvalid';

interface Props {
    name: string;
    value: string;
    placeholder?: string;
    handleChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
    label: string;
    required?: boolean;
    error: string;
    inputClasses?: string;
}

const FormGroupTextArea: React.FC<Props> = ({
    name,
    value,
    placeholder,
    handleChange,
    label,
    required,
    error,
    inputClasses = '',
    ...customValues
}) => {
    const hasError = (error ?? false) !== false;

    return (
        <div className="form-group">
            <label htmlFor={name}>
                {label} {required === true && <span className="text-danger text-sm">*</span>}
            </label>
            <textarea
                className={`form-control ${hasError ? 'is-invalid' : ''} ${inputClasses ?? ''}`}
                id={name}
                placeholder={placeholder ?? ''}
                name={name}
                value={value ?? ''}
                onChange={handleChange}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...customValues}
            />
            {hasError && <FormInvalid message={error} />}
        </div>
    );
};

export default FormGroupTextArea;
